import { render } from "./YeniAltlikAdiInputSvg.vue?vue&type=template&id=22779afe"
import script from "./YeniAltlikAdiInputSvg.vue?vue&type=script&lang=js"
export * from "./YeniAltlikAdiInputSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__